import Cookie from './cookie';
import { Settings } from "./ordercall";


export default class OrdercallService {
    URL = '?plugin=ordercall';
    JSON_URL = this.URL + '&module=json';
    _csrf: string;

    constructor() {
        this._csrf = Cookie.get('_csrf');
    }

    ips() {
        return this.getByAction('order&method=ips');
    }

    deleteAll() {
        return this.getByAction('order&method=deleteAll');
    }

    getActionUrl(action: string): string {
        let url = this.JSON_URL + '&action=' + action;

        return url;
    }

    getByAction(action: string) {
        return this.get(this.getActionUrl(action));
    }

    postByAction(action: string, data: any) {
        return this.post(this.getActionUrl(action), data);
    }

    getSettings() {
        return this.getByAction('settings&method=get');
    }

    saveSettings(settings: Settings) {
        let data = {
            _csrf: this._csrf,
            settings: settings
        };
        return this.postByAction('settings&method=save', data);
    }

    get(url: string) {
        return $.get(url);
    }

    post(url: string, data: any) {
        return $.post(url, data);
    }

    static paramsToUrl(params: any): string {
        let query = '';

        for(let key of Object.keys(params)) {
            query += key + '=' + params[key] + '&';
        }

        return query;
    }
} 


// WEBPACK FOOTER //
// ./src/webpack/vue/ordercall.service.ts